/**
 * AlphaSense Agent Parameter Schema
 *
 * IMPORTANT: All array and boolean types must have explicit descriptions
 * to help the LLM generate correct JSON types (not stringified values).
 */
import { z } from "zod";
export const AlphaSenseParamsSchema = z.object({
    // Base params - explicit descriptions for proper JSON generation
    requirements: z.array(z.object({
        id: z.string().describe("Requirement identifier like 'A', 'B', 'C'"),
        requirement: z.string().describe("The specific research requirement text"),
    })).describe("Array of research requirements to fulfill. Must be a JSON array, not a string."),
    uiDescription: z.string()
        .describe("Single-line UI description for top-of-card agent status display."),
    uiDescriptions: z.array(z.string())
        .optional()
        .describe("Optional list of UI description lines for the top section of agent-as-tool cards."),
    context: z.array(z.object({
        context: z.array(z.string()).describe("Array of context IDs like 'as_abc12', 'd0|slide_257'"),
        purpose: z.string().describe("Description of what this context is for"),
    })).optional().describe("Optional array of context items with context IDs"),
    threadId: z.string().optional().describe("Optional thread ID for conversation continuation"),
    // AlphaSense-specific
    preferFinData: z.boolean()
        .optional()
        .default(false)
        .describe("Set to true (boolean, not string) for numerical financial queries like revenue, EPS, margins"),
});
